module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MaterialDetailView.js"));
	}, "MaterialDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MaterialDetailView!./src/pages/Promote/MaterialCenter/MaterialDetail/MaterialDetailView.js
// module id = 2055
// module chunks = 367